import React from 'react';
import type { FrontEndMonitoringProps } from './frontEndMonitoring.types';
import { useFrontEndMonitoring } from './useFrontEndMonitoring';

/**
 * Mounts the front-end monitoring hook without rendering any markup.
 * Passes hasCheckedLoginStatus to useFrontEndMonitoring and renders null.
 *
 * @param props - The hasCheckedLoginStatus flag forwarded to the monitoring hook.
 * @returns Null, since the component renders nothing.
 */
const FrontEndMonitoring = ({
  hasCheckedLoginStatus,
}: FrontEndMonitoringProps): React.ReactElement | null => {
  useFrontEndMonitoring({ hasCheckedLoginStatus });

  return null;
};

export default FrontEndMonitoring;
